var _rect, _rect2, _rect3, _path, _circle, _circle2, _path2, _circle3, _circle4, _circle5, _line, _path3, _line2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEcom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 641,
    height: 641,
    viewBox: "0 0 641 641",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 641,
    height: 641,
    fill: "url(#paint0_linear_4_102)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 72.5,
    y: 164.5,
    width: 497,
    height: 308,
    stroke: "black",
    strokeWidth: 7
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 72.5,
    y: 164.5,
    width: 497,
    height: 47,
    stroke: "black",
    strokeWidth: 7
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M536.721 174.818L542.994 185.523L549.266 174.818H553.903L545.448 187.909L553.903 201H549.266L542.994 190.841L536.721 201H532.085L540.403 187.909L532.085 174.818H536.721Z",
    fill: "black"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 106,
    cy: 189,
    r: 10,
    fill: "black"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 142,
    cy: 189,
    r: 10,
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M229 321H418V389C418 416.614 395.614 439 368 439H279C251.386 439 229 416.614 229 389V321Z",
    fill: "black"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 370,
    cy: 353,
    r: 10,
    fill: "#F5F5F5"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 380,
    cy: 439,
    r: 10,
    fill: "black"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 272,
    cy: 439,
    r: 10,
    fill: "black"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 202.74,
    y1: 287.967,
    x2: 257.74,
    y2: 338.967,
    stroke: "black",
    strokeWidth: 11
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M206.167 283L184.561 307.766",
    stroke: "black",
    strokeWidth: 11
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 182.767,
    y1: 301.993,
    x2: 232.767,
    y2: 348.993,
    stroke: "black",
    strokeWidth: 11
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4_102",
    x1: 4.13044e-8,
    y1: 319.167,
    x2: 641,
    y2: 321.833,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7465D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C00C7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEcom);
export default __webpack_public_path__ + "static/media/ecom.c0f3ff64c4cd23993c9cebd47fe5d78d.svg";
export { ForwardRef as ReactComponent };